<header class="header text-center" >
    <img src="assets/images/logo.png" alt="logo">
</header>

<section>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-10 text-center">
                <div class="boxConainer verify">
                    <h1>Verification</h1>
                    <div class="verificaton row"  >
                        <div class="col-sm-6">
                            <figure>
                                <img src="assets/images/varification-img.jpg" height="80" width="80" id="currentImage" alt="verification">
                                <figcaption>Your Database Picture</figcaption>
                            </figure>
                        </div>
                        <div class="col-sm-6">
                            <figure>
                                <img  src="assets/images/varification-img.jpg" height="80" width="80" id="dbImage" alt="verification">
                                <figcaption>Your Current Picture</figcaption>
                            </figure>
                        </div>
                    </div>
                    <img src="assets/images/not-verified.svg" alt="not-verified">
                    <p>
                        Your photo is not matched successfully  <br>
                        with our database image.
                    </p>
                    <button type="button" class="btn btn-lg">Proceed</button>
                    <p><small>Not Satisfied? <a href="#">Reshoot Video</a></small></p>
                </div>
            </div>
        </div>
    </div>
</section>
